import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { TaskForm } from './task-form';
import { useAddTaskForm } from './use-add-task-form';

export const AddTaskDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { initialValues, handleSubmit } = useAddTaskForm(onClose);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Новая задача</DialogTitle>
      <DialogContent>
        <TaskForm onSubmit={handleSubmit} onCancel={onClose} initialValues={initialValues} />
      </DialogContent>
    </Dialog>
  );
};
